import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconVideo(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20 4H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2Zm0 14H4V6h16v12Zm-4-6-7 4V8l7 4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
